import clsx from 'clsx'
import React, { FunctionComponent } from 'react'

import { Icon, IconSizes } from '../Icon'
import { DesignLanguage, useIsDesignLanguage, useThemeClass } from '../Theme'
import { Text } from '../Typography'
import styles from './style.module.scss'
import { ActionCardProps } from './types'

export const ActionCard: FunctionComponent<ActionCardProps> = ({
  onClick,
  label,
  labelSize = 'M',
  iconName,
  disabled,
  testNameSpace = '',
  tabIndex = 0,
  position = 'Default',
  ...otherProps
}) => {
  const isBronteDesign = useIsDesignLanguage(DesignLanguage.Bronte)
  const themeClass = useThemeClass()
  const buttonClassNames = clsx(styles.button, disabled && styles.disabled, styles[position], styles[themeClass])
  const iconContainerClassNames = clsx(styles.iconContainer, styles[themeClass])

  const iconSize: IconSizes = isBronteDesign ? 'Mini' : 'ExtraSmall'
  const hasTestNameSpace = testNameSpace.length > 0
  const baseTestNameSpace = hasTestNameSpace ? `${testNameSpace}-action-card` : ''

  return (
    <button
      tabIndex={tabIndex}
      className={buttonClassNames}
      onClick={onClick}
      disabled={disabled}
      {...(hasTestNameSpace && { 'data-testid': baseTestNameSpace })}
      aria-disabled={disabled}
      {...otherProps}
    >
      <div className={iconContainerClassNames} {...(hasTestNameSpace && { 'data-testid': `${baseTestNameSpace}-icon-container` })}>
        <Icon size={iconSize} name={iconName} title={iconName} description={`${iconName} icon`} role='img' />
      </div>
      <div className={styles.textContainer}>
        <Text bold size={labelSize}>
          {label}
        </Text>
      </div>
    </button>
  )
}
